import http from "../http-common";
import md5 from "md5";

const getAll = async () => {
  return await http
    .get("/platform")
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

export default {
  getAll,
};
